import { useEffect } from "react";
import CustomFilter from "../../../Common/CustomFilter";

const FilterComponent = (props) => {
  // Props
  const {
    tableData,
    filterAPI,
    filterName,
    searchButtonText,
    defaultOpen,
    showFilter,
    setShowFilter,
    handleFilter,
    isPreview = false,
    previewFunction = () => {},
    filterValues,
    setFilterValues,
    preview = "Preview",
    setTableData,
  } = props;

  useEffect(() => {
    if (defaultOpen) {
      setShowFilter(true);
    }
  }, [defaultOpen, setShowFilter]);

  useEffect(() => {
    if (defaultOpen) {
      setShowFilter(true);
    }
  }, [defaultOpen, setShowFilter]);

  return (
    <CustomFilter
      showFilter={showFilter}
      tableData={tableData}
      fetchTableData={filterAPI}
      filterName={filterName ? filterName : "configuration"}
      searchButtonText={searchButtonText}
      handleFilter={handleFilter}
      isPreview={isPreview}
      previewFunction={previewFunction}
      filterValues={filterValues}
      setFilterValues={setFilterValues}
      preview={preview}
      setTableData={setTableData}
    />
  );
};

export default FilterComponent;
